// rootReducer.ts
import { combineReducers } from '@reduxjs/toolkit';
import { authReducer } from './slices/authSlice';
import { staticReducer } from './slices/staticSlice';
import { deviceReducer } from './slices/deviceSlice';
import { profileReducer } from './slices/profileSlice';
import myBookReducer from './slices/myBookSlice';

const rootReducer = combineReducers({
    auth: authReducer,
    staticData: staticReducer,
    device: deviceReducer,
    profiles: profileReducer,
    myBook: myBookReducer,
});

export default rootReducer;
